import { AxiosError, type InternalAxiosRequestConfig } from 'axios';

/**
 * Staff opening another PPJK's manifest draft (not impersonating) can use the
 * whole editor — open dialogs, run syncs, print — but nothing they do is
 * saved. While the editor holds the block, a write to the draft is answered
 * here, without reaching the backend, with the same 403 its ownership guard
 * gives (ManifestGuard), so the usual "Perubahan tidak disimpan" toast shows
 * and callers fail the way they do for a server refusal.
 */
let blocked = false;

export const setManifestWriteBlock = (on: boolean) => {
  blocked = on;
};

// What the editor writes: the manifest itself, its reminders, uploaded files
// and the jarvis manifest reads (NOA, PEB / BL susulan) that insert into it.
const DRAFT_WRITE = /\/(nvocc-manifest|manifest-reminders|nvocc-reminders|ceisa\/uploads|manifest)\//i;

// POSTs that only read (backend rbac ReadSafeSuffixes), plus the port lookup.
const READ_SAFE = /\/(search|filter|list|preview|count|summary|report|suggest|generate-excel|download|print|lookup)\b/i;

export const isBlockedManifestWrite = (config: Pick<InternalAxiosRequestConfig, 'method' | 'url'>): boolean => {
  if (!blocked) return false;
  const method = String(config.method || 'get').toLowerCase();
  if (method === 'get' || method === 'head' || method === 'options') return false;
  const url = config.url ?? '';
  return DRAFT_WRITE.test(url) && !READ_SAFE.test(url);
};

export const blockedWriteAdapter = (config: InternalAxiosRequestConfig) =>
  Promise.reject(
    new AxiosError('Dokumen ini milik PPJK lain. Perubahan tidak disimpan.', 'ERR_BAD_REQUEST', config, undefined, {
      status: 403,
      statusText: 'Forbidden',
      data: { success: false, code: 'FORBIDDEN_CROSS_TENANT', message: 'Dokumen ini milik PPJK lain.' },
      headers: {},
      config,
    })
  );
